export function locationsSlider() {
    $(window).on("load", () => {
        const $slider = $(".locations-section-slider");
        $slider.slick({
            mobileFirst: true,
            slidesToShow: 6,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 1000,
            arrows: false,
            infinite: true,
            dots: false,
            pauseOnHover: false,
            responsive: [{
                breakpoint: 1199,
                settings: {
                    slidesToShow: 6,
                    dots: false,
                    arrows: true,
                }
            },{
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                    dots: false,
                    arrows: true,
                }
            },{
                breakpoint: 567,
                settings: {
                    slidesToShow: 2,
                    dots: false,
                    arrows: true,
                }
            },{
                breakpoint: 319,
                dots: true,
                settings: {
                    slidesToShow: 1,
                    dots: false,
                    arrows: true,
                }
            }]
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/locations-section-slider.js